export default __webpack_public_path__ + "static/image3-5a97c4dcdab3c73463a76f662aa014f7.svg";